import React, { useEffect, useState } from 'react';
import { Layout } from '../../../components';
import { Tevent, initialEvent } from '../../../type/event';
import { useParams } from 'react-router-dom';
import { getDataDetail } from '../../../service/eventService';
import { MINIO } from '../../../data/data';
import { FiCalendar } from 'react-icons/fi';
import { currency } from '../../../utls/number';

const DetailEvent = () => {
	const [event, setEvent] = useState<Tevent>(initialEvent);

	const { slug } = useParams();

	const getDataNewsDetail = async (slug: string) => {
		const response = await getDataDetail(slug);
		if (!response?.error) {
			setEvent(response?.data);
		}
	};

	useEffect(() => {
		getDataNewsDetail(slug || '');
	}, []);

	return (
		<Layout
			title="Event"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="mt-[4rem]">
				<div className="bg-gray-50 text-center overflow-hidden rounded-lg mb-4">
					<img
						src={`${MINIO}/${event.thumbnail}`}
						className=""
						alt={event.name}
					/>
				</div>
				<h2 className="text-[18px] font-medium mt-2">{event.name}</h2>
				<span className="text-[10px] text-gray-400 m-0 p-0 flex item-center">
					<FiCalendar className="mr-2" />
					{new Date(event.createDate).toLocaleDateString()} - {' '}
					{new Date(event.createDate).toLocaleTimeString()}
				</span>
				<div className="my-3 text-[12px]">
					<table>
						<tbody>
							<tr>
								<td className="w-[120px]">Mulai</td>
								<td>: {new Date(event.startDate).toLocaleDateString()}</td>
							</tr>
							<tr>
								<td>Selesai</td>
								<td>: {new Date(event.endDate).toLocaleDateString()}</td>
							</tr>
							<tr>
								<td>HTM</td>
								<td>
									: {event.price ? currency(parseFloat(event.price)) : 'Rp 0'}
								</td>
							</tr>
							<tr>
								<td>Location</td>
								<td>: {event.location}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<h4 className="text-[12px]">Deskripsi</h4>
				<div
					className="mt-2"
					dangerouslySetInnerHTML={{ __html: event.content }}
				/>
			</div>
		</Layout>
	);
};

export default DetailEvent;
